import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsOfferListItem } from './components/models/cms-offer-list';
import { CmsOfferDetail, CmsOfferDetailDto } from './components/models/cms-offer-detail';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CmsOfferService {

  public apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

 public getCmsOfferList(statuses: string[] = ['Active']): Observable<CmsOfferListItem[]> {
 return this.http.get(`${this.apiUrl}OfferDecorator`, { params: { status: statuses } }) as Observable<CmsOfferListItem[]>;
  }

  public getCmsOfferDetail(id: string): Observable<CmsOfferDetail> {
    return this.http.get(`${this.apiUrl}OfferDecorator/${id}`) as Observable<CmsOfferDetail>;
  }

  public updateCmsOfferDetail(offer: CmsOfferDetail): Observable<CmsOfferDetail> {
    return this.http.put(`${this.apiUrl}OfferDecorator/${offer.id}`, offer) as Observable<CmsOfferDetail>;
  }

  public createCmsOfferDetail(offer: CmsOfferDetailDto): Observable<CmsOfferDetail> {
    return this.http.post(`${this.apiUrl}OfferDecorator`, offer) as Observable<CmsOfferDetail>;
  }

  public deleteCmsOfferDetail(offer: CmsOfferListItem) {
    return this.http.delete(`${this.apiUrl}OfferDecorator/${offer.id}`);
  }

  public uploadBatchOffers(file: any) {
    const formData = new FormData();
    formData.append('file', new Blob([file], { type: file.type }), file.name);

    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');

    return this.http.post(`${this.apiUrl}OfferDecorator/batch-import`, formData, { headers });
  }

  public batchArchiveOffers(externalIdentifiers: string[], mode: 'archive' | 'archive-except'): Observable<any> {
    return this.http.post(`${this.apiUrl}OfferDecorator/batch-archive`, { ids: externalIdentifiers, mode });
  }
}